import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-bandwidth',
  templateUrl: './bandwidth.component.html',
  styleUrls: ['./bandwidth.component.scss']
})
export class BandwidthComponent implements OnInit {
  reportSection: boolean;
  
  constructor(private _Activatedroute: ActivatedRoute) { }

  ngOnInit() {
    console.log("ARRIVO ONINIT");
    this._Activatedroute.queryParams.subscribe(params => {
      this.reportSection = params['reportSection'];
    });
  }

}
